import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import SwissBadge from "@/components/SwissBadge";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [token, setToken] = useState(""); // debug dev only

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.debug_token) setToken(data.debug_token);
      toast.success("Wenn das Konto existiert, wurde eine E-Mail gesendet.");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-8" data-testid="forgot-password-page">
      <div className="w-full max-w-md space-y-6">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-900">
          <ArrowLeft className="h-4 w-4" /> Zurück zum Login
        </Link>
        <div className="flex items-center" data-testid="forgot-brand">
          <img src="/easy-gutachter-logo.png" alt="Easy Gutachter" className="h-20 w-auto select-none" draggable={false} />
        </div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Passwort zurücksetzen</h1>
        {sent ? (
          <div className="rounded-xl border border-[#12A9E8]/30 bg-[#12A9E8]/10 p-4 text-sm text-[#12A9E8]">
            E-Mail mit Reset-Link gesendet (sofern Konto existiert).
            {token && (
              <div className="mt-3 text-xs">
                <strong>Dev:</strong> <Link to={`/reset-password?token=${token}`} className="underline">Link öffnen</Link>
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" className="w-full brand-gradient-bg text-white" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
              Reset-Link anfordern
            </Button>
          </form>
        )}
        <div className="flex justify-center pt-2">
          <SwissBadge />
        </div>
      </div>
    </div>
  );
}
